// extracted by mini-css-extract-plugin
module.exports = {"container":"no_link_legislation_title-module__container--2QlA3","iconWrapper":"no_link_legislation_title-module__iconWrapper--1Fy0Z"};